import { makeAutoObservable } from "mobx";
import API, { FieldType, IEntityColumn, IUserConfigPackage } from "../../API";

import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Dropdown, IDropdownOption, Spinner, SpinnerSize, Stack, StackItem } from "@fluentui/react";

export class FieldPickerState {

	public userConfig: IUserConfigPackage;
	
	public listUrl:string = '';
	
	public selectedFieldInternalName: string = '';
	fieldType: FieldType | undefined;
	public setSelectedFieldInternalName(arg0: string) {
		this.selectedFieldInternalName = arg0;
	}

	public availableColumns?: IEntityColumn[];
	public setAvailableColumns(columns:IEntityColumn[]) {
		this.availableColumns = columns;
	}

	public loading:boolean = false;
	public setLoading(arg0: boolean) {
		this.loading = arg0;
	}

	constructor(
		userConfig: IUserConfigPackage,
		listUrl:string,
		selectedFieldInternalName:string,
		fieldType: FieldType | undefined = undefined
	) {
		makeAutoObservable(this);
		this.userConfig = userConfig;
		this.listUrl = listUrl;
		this.selectedFieldInternalName = selectedFieldInternalName;
		this.fieldType = fieldType;
	}

	async ensureListLoaded() {
		if(!this.availableColumns) {
			var api = new API(await this.userConfig.getToken());
			var cols = await api.getListFields(this.listUrl);
			this.setAvailableColumns(cols);
		}
	}
}

export interface IFieldPickerProps {
	config:IUserConfigPackage;
	listUrl: string;
	preloadedFields?:IEntityColumn[];
	selectedFieldInternalName: string;
	fieldType?: FieldType;
	onFieldPicked: (fieldInternalName:string) => void;
}

function FieldPicker(props:IFieldPickerProps) {

	const [state] = useState(() => {
		let result = new FieldPickerState(
			props.config,
			props.listUrl,
			props.selectedFieldInternalName,
			props.fieldType
		);
		if (props.preloadedFields) {
			result.setAvailableColumns(props.preloadedFields);
		}
		return result;
	});
	
	useEffect(() => {
		state.ensureListLoaded();
	}, [state]);

	const urlFields = state.availableColumns ?? [];
	const urlFieldDropdownOptions = urlFields.map((c) => {
		return {
			key: c.id,
			text: `${c.displayName} (${c.id})`,
		} as IDropdownOption;
	}).sort((a,b) => (a.text || '').toLowerCase().localeCompare((b.text || '').toLowerCase()));

	const selectedFieldKey =
		urlFields.find((c) => c.id === state.selectedFieldInternalName)?.id ??
		urlFields[0]?.id ??
		'';

	return <Stack horizontal>
			<StackItem grow>
				<Dropdown
					disabled={
						!state.listUrl ||
						!state.availableColumns ||
						state.availableColumns.length === 0 ||
						state.loading
					}
					options={urlFieldDropdownOptions}
					selectedKey={selectedFieldKey}
					onChange={(e, option) => {
						state.setSelectedFieldInternalName(option?.key as string);
						props.onFieldPicked(option?.key as string);
					}}
				/>
			</StackItem>
			<StackItem>
				{state.loading && (
					<Spinner size={SpinnerSize.medium} />
				)}
			</StackItem>
		</Stack>;
}

export default observer(FieldPicker);
